import React from 'react';
import { Box, Divider, List, Typography } from '@mui/material';
import {
    MetricMatrix,
    PanelFrame,
} from './SharedFrames';
import VyasaModelScores from './VyasaModelScores';
import { snapshotPanelCopy } from '../strategySnapshotBuilders';

const StrategySnapshotPanel = ({
    strategyFamily,
    executionMode = 'simulation',
    title,
    description,
    action,
    headlineMessage,
    stateCommentary,
    metrics = [],
    modelScores,
    modelScoresAsOf,
    minHeight,
    framed = true,
}) => {
    const copy = snapshotPanelCopy(strategyFamily, executionMode);
    const panelTitle = title || copy.title;
    const panelDescription = description || copy.description;

    const content = (
        <>
            <Typography
                variant="body1"
                sx={{
                    fontWeight: 700,
                    lineHeight: 1.6,
                }}
            >
                {headlineMessage || 'Awaiting strategy telemetry…'}
            </Typography>
            {strategyFamily !== 'vyasa' && stateCommentary ? (
                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.65 }}>
                    {stateCommentary}
                </Typography>
            ) : null}
            <Divider />
            <MetricMatrix
                metrics={metrics}
                columns={{ xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))', xl: 'repeat(3, minmax(0, 1fr))' }}
            />
            {strategyFamily === 'vyasa' ? (
                <VyasaModelScores scores={modelScores} asOf={modelScoresAsOf} />
            ) : null}
        </>
    );

    if (!framed) {
        return <Box>{content}</Box>;
    }

    return (
        <PanelFrame
            accent="strategy"
            eyebrow="Session Context"
            title={panelTitle}
            description={panelDescription}
            action={action}
            minHeight={minHeight}
        >
            {content}
        </PanelFrame>
    );
};

export default StrategySnapshotPanel;
